export default __webpack_public_path__ + "static/media/361.1796b6f5.svg";